module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[82]569.beaca74.woff2";